import { useBlokkli } from "../../composables/useBlokkli.js";
import { onBeforeUnmount, onMounted } from "#imports";
export default function(shortcut) {
  const { keyboard } = useBlokkli();
  onMounted(() => {
    if (Array.isArray(shortcut)) {
      shortcut.forEach((v) => keyboard.registerShortcut(v));
      return;
    }
    keyboard.registerShortcut(shortcut);
  });
  onBeforeUnmount(() => {
    if (Array.isArray(shortcut)) {
      shortcut.forEach((v) => keyboard.unregisterShortcut(v));
      return;
    }
    keyboard.unregisterShortcut(shortcut);
  });
}
